import type { FieldError as FormFieldError, Path, UseFormReturn } from 'react-hook-form';
import { AutosizeTextArea, FieldError, FormField, FormGroup } from '@gonfalon/legacy-forms/components';
import { msg } from '@gonfalon/messages/msg';

import type { CommentFormSchema } from '../schemas';

type SaveChangesCommentFormProps<T extends CommentFormSchema> = {
  form: Pick<UseFormReturn<T>, 'register' | 'formState'>;
};

export function CommentForm<T extends CommentFormSchema>({ form }: SaveChangesCommentFormProps<T>) {
  const {
    register,
    formState: { errors },
  } = form;

  return (
    <FormGroup name="comment">
      <FormField
        isRequired={false}
        label={msg('ui.saveChangesModal.commentLabel')}
        name="comment"
        htmlFor="comment"
        hint={msg('ui.saveChangesModal.commentHint')}
      >
        <AutosizeTextArea {...register('comment' as Path<T>)} id="comment" name="comment" rows={1} maxRows={4} />
      </FormField>
      <FieldError name="comment" errorMessage={(errors.comment as FormFieldError)?.message} />
    </FormGroup>
  );
}
